import React, { useEffect, useMemo, useRef } from 'react';
import { Container, Sprite } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import { gameDrawer } from '../../../../services/gameDrawer';
import { gameResourcesService } from '../../../../services/gameResourcesService';

import { isMobile } from '../../../../core/helpers/isMobile';

import TextOrderingByWidth from '../../textOrderingByWidth';
import { isoStandard } from '../../../../core/helpers/isoStandard';
import { applicationStore } from '../../../../store/applicationStore';

const LastWinAmountComponent = observer(
  ({
    isVisible,
    amountValue,
    currencySymbol,
    backGroundTexture,
    canvasTranslationKeys,
    hasBackGround = true,
    x = 0,
    y = 0,
  }) => {
    const { isShowLicenseMode, isDemo } = applicationStore;
    const lastWinAmountTextureRef = useRef(null);

    const texts = useMemo(() => {
      return [
        {
          id: 0,
          text: canvasTranslationKeys.LAST_WIN,
          style: { fill: '#FFC33E', _fontWeight: 700, _fontSize: isMobile() ? 20 : 24 },
          ref: null,
        },
        {
          id: 1,
          text: isoStandard(amountValue, true),
          style: { fill: '#FFFFFF', _fontWeight: 700, _fontSize: isMobile() ? 24 : 30 },
          ref: lastWinAmountTextureRef,
        },
        {
          id: 2,
          text: currencySymbol,
          style: { fill: '#FFFFFF', _fontWeight: 700, _fontSize: isMobile() ? 20 : 24 },
          ref: null,
        },
      ];
    }, [amountValue, canvasTranslationKeys, currencySymbol]);

    const updateTextByLicense = useMemo(() => {
      return isShowLicenseMode && !isDemo ? [texts[0], texts[2], texts[1]] : texts;
    }, [isShowLicenseMode, isDemo, texts]);

    useEffect(() => {
      if (lastWinAmountTextureRef.current) {
        gameResourcesService.setWinAmountTexture(lastWinAmountTextureRef.current);
        gameDrawer.animateWinAmount({ value: amountValue, duration: 0 });
      }
    }, [lastWinAmountTextureRef, amountValue]);

    return (
      <Container name='LastWinAmountComponent' visible={isVisible} x={x} y={y}>
        {hasBackGround && (
          <Sprite anchor={0.5} scale={isMobile() ? 0.77 : 0.5} texture={backGroundTexture} />
        )}
        <TextOrderingByWidth texts={updateTextByLicense} />
      </Container>
    );
  }
);

export default LastWinAmountComponent;
